<template>
    <div class="profile-loader text-center py-5">
        <div class="loader-spinner mb-3">
            <base-table-spinner />
        </div>
        <div class="loader-text">
            <h4 class="mb-2">{{ loadingMessage }}</h4>
            <p class="text-muted">{{ subMessage }}</p>
        </div>
    </div>
</template>

<script>
import BaseTableSpinner from '@/components/BaseTableSpinner.vue'

export default {
    name: 'BaseProfileLoader',
    components: {
        BaseTableSpinner
    },
    props: {
        sectionName: {
            type: String,
            default: 'profile data'
        },
        subMessage: {
            type: String,
            default: 'Please wait while we fetch the latest information'
        }
    },
    computed: {
        loadingMessage() {
            return `Loading ${this.sectionName}...`
        }
    }
}
</script>

<style scoped>
.profile-loader {
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.loader-spinner {
    opacity: 0.7;
}

.loader-text h4 {
    font-size: 1.1rem;
    font-weight: 500;
    color: #495057;
}

.loader-text p {
    font-size: 0.9rem;
    margin-bottom: 0;
}
</style>